import { render, staticRenderFns } from "./AddLeadResultItemIcon.vue?vue&type=template&id=3ae44b4d&"
import script from "./AddLeadResultItemIcon.vue?vue&type=script&lang=js&"
export * from "./AddLeadResultItemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports